import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";

const ExperienceList = ({ value }) => {
  let items = value;
  if (typeof items === "string") {
    try {
      items = JSON.parse(items);
    } catch {
      items = [];
    }
  }
  if (!Array.isArray(items) || items.length === 0)
    return <Typography color="text.secondary">-</Typography>;

  return (
    <Box>
      {items.map((exp, idx) => (
        <Box
          key={idx}
          sx={{
            mb: 2,
            p: 1.5,
            border: "1px solid #eee",
            borderRadius: 1,
            background: idx % 2 === 0 ? "#f7f7f7" : "#fff",
          }}
        >
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            {exp.jobTitle || "-"} <span style={{ color: "#777" }}>at</span> {exp.companyName || "-"}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {exp.startDate ? dayjs(exp.startDate).format("YYYY-MM-DD") : "?"}
            {" — "}
            {exp.endDate ? dayjs(exp.endDate).format("YYYY-MM-DD") : "?"}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <span style={{ fontWeight: 500 }}>Reason for Leaving:</span>{" "}
            {exp.reasonForLeaving || "-"}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            <span style={{ fontWeight: 500 }}>Main Responsibilities:</span>{" "}
            {exp.responsibilities || "-"}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ExperienceList;
